import { styled, Box, Typography } from '@mui/material';
import ProfileCircle from 'assets/icons/ProfileCircle';
import { palette } from 'assets/styles/colors';

const userProfileBackground = palette.blue[700];

export const Wrapper = styled(Box)`
  background: ${userProfileBackground};
  border-radius: ${({ theme }) => theme.radius?.md};
  display: flex;
  height: 100%;
  padding: ${({ theme }) => theme.spacing(2)};
  word-break: break-word;
  color: white;
  .MuiTypography-h1 {
    color: ${userProfileBackground};
  }
  svg > path {
    fill: white;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    align-items: center;
  }
`;

export const StyledBox = styled('div')`
  width: 100%;
`;

export const ProfileIcon = styled(Box)`
  @media (max-width: 349px) {
    display: none;
  }
  align-items: center;
  align-self: center;
  display: flex;
  justify-content: center;
  margin-right: 16px;
`;

export const InitialsCircle = styled(ProfileCircle)`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 146px;
    width: 146px;
  }
`;

export const UserInitials = styled(Typography)`
  font-size: 44px;
  margin: 0;
  position: absolute;
`;

export const Label = styled(Typography)`
  font-weight: 600;
`;

export const QRBox = styled('div')`
  display: flex;
  justify-content: flex-end;
`;
